import React, { type JSX } from 'react';
import { IColumn } from '../../../../../Queries/EkonomiskAnalysSettingsQuery/EkonomiskAnalysSettingsQuery';
import {
  NEW_ANALYS_TEMPLATE_NAME,
  templateData,
} from './AvailableColumnTemplatesQueryData';

export interface IColumnTemplate {
  id: string;
  name: string;
  canHavePrevYearCols: boolean;
  columns: IColumn[];
}

interface IProps {
  children: (availableColumnTemplates: IColumnTemplate[]) => JSX.Element;
}

export const getNewAnalysColumns = (
  availableColumnTemplates: IColumnTemplate[]
) => {
  return (
    availableColumnTemplates.find(
      template => template.name === NEW_ANALYS_TEMPLATE_NAME
    )?.columns ?? []
  );
};

const AvailableColumnTemplatesHandler: React.FC<IProps> = (props: IProps) => {
  let columnTemplates: IColumnTemplate[] =
    templateData.ekanalyscolumntemplates
      ?.filter(x => x.columns !== null)
      .map((x, index) => {
        const columns = x.columns;
        const data: IColumn[] = columns.map(
          (column, columnIndex): IColumn => ({
            name: x.name || '',
            id: columnIndex,
            data: {
              __typename: 'TEDAvenyEKAnalysColumn',
              LOPNR: columnIndex,
              ORDNINGS_NR: null,
              FALTKOD: column.faltKod,
              INTERN: null,
              RESULTAT_TYP: column.resultatTyp,
              FALT_TYP: column.faltTyp,
              INTERVALL_TYP: column.intervallTyp,
              BAS: column.bas,
              ANTAL_DECIMALER: column.antalDecimaler,
              VAND_TECKEN: column.vandTecken,
              BENAMNING: column.rubrik1,
              BENAMNING2: column.rubrik2,
              CODE_CAPTION: null,
              FROM_AR: column.fromAr,
              FROM_AR_RELATIV: column.fromArRelativ,
              TOM_AR: column.tomAr,
              TOM_AR_RELATIV: column.tomArRelativ,
              FROM_PER: column.fromPer,
              FROM_PER_RELATIV: column.fromPerRelativ,
              TOM_PER: column.tomPer,
              TOM_PER_RELATIV: column.tomPerRelativ,
              ENHET_ID: null,
              CategoryPath: null,
              Mallkolumn: null,
              MallValidCategories: null,
              RULLANDE: column.rullande,
              RULLANDE_PERIOD_TYP: null,
              RULLANDE_PERIOD_ANTAL: null,
              BUDGETTYP: column.budgetTyp,
              HIDE_COLUMN: !column.synlig,
              BUDGETBENAMNING: column.budgetBenamning,
              FORCE_CALCULATE: null,
              SPECIFIKATION: null,
            },
          })
        );
        return {
          name: x.name,
          id: index.toString(),
          canHavePrevYearCols: x.canHavePrevYearCols,
          columns: data,
        };
      }) ?? [];
  return props.children(columnTemplates);
};

export default AvailableColumnTemplatesHandler;
